import { RouterProvider } from '@tanstack/react-router';
import { LoginScreen } from '@/features/auth/LoginScreen';
import { useAuth } from '@/lib/auth';
import { router } from './router';

/** Auth gate: the in-app router only mounts once /me confirms an allowed user. */
export function App() {
  const { status } = useAuth();
  if (status === 'authenticated') return <RouterProvider router={router} />;
  return <LoginScreen />;
}
